import React, { useState, useEffect } from "react";

import {
  Row,
  Col,
  FormControl,
  Checkbox,
  HelpBlock,
  FormGroup,
} from "react-bootstrap";

import PageTitleNew from "../../../ui/PageTitleNew";

import { useEditCoachPoolContext } from "../../../../contexts/EditCoachPoolContext";

export default function Form() {
  const { dispatch, actions, state } = useEditCoachPoolContext();

  const [isDefault, setDefault] = useState(state.coachPool.attributes.default);

  const handleCoachPoolNameChange = (name) => {
    actions.updateCoachPoolName(dispatch, name);
  };

  const handleDefaultChange = (e) => {
    actions.updateCoachPoolDefault(dispatch, e.target.checked);
  };

  return (
    <>
      <PageTitleNew
        title={`Edit Coach Pool - ${state.coachPool.attributes.name}`}
      />

      <div className="ibox-content mt20">
        <Row>
          <Col md={6}>
            <FormGroup
              validationState={state.coachPoolNameError == "" ? null : "error"}
            >
              <FormControl
                type="text"
                value={state.coachPool.attributes.name}
                placeholder="Enter coach pool name"
                onChange={(e) => handleCoachPoolNameChange(e.target.value)}
              />
              <HelpBlock>{state.coachPoolNameError}</HelpBlock>
            </FormGroup>
            {state.coaches != null && (
              <div className="mt10">
                Number of Coaches: {state.coachSelected.length} of{" "}
                {state.coaches.length}
              </div>
            )}

            <div>
              <Checkbox
                checked={state.coachPool.attributes.default}
                onChange={handleDefaultChange}
              >
                Default Pool (Assign to all new Teams automatically)
              </Checkbox>
            </div>
          </Col>
          <Col className="text-right" md={6}>
            <a
              className="btn btn-green w-150"
              onClick={() => actions.selectAllRecords(dispatch, false)}
            >
              Remove All
            </a>
            <a
              className="btn btn-green w-150 ml5"
              onClick={() => actions.selectAllRecords(dispatch, true)}
            >
              Add All
            </a>
          </Col>
        </Row>
      </div>
    </>
  );
}
